import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { hapticImpact } from '../utils/haptic'

/**
 * Переход на карточку банды по slug — внутренний экран /teams/:slug
 * (GET /api/team/{slug}/).
 *
 * slug приходит в блоке `team` рядом с игроком (в кейсбатлах — `user_team`):
 * строка 32 символов [a-z0-9]. Весь блок `team` может быть null — человек не
 * состоит в банде, бейджа нет вовсе, клика тоже.
 *
 * Бейдж банды почти всегда лежит внутри кликабельной ссылки на профиль
 * и/или карточки, поэтому обработчик останавливает всплытие: из одной строки
 * ведут два разных перехода — на профиль и на банду.
 */
const useOpenTeam = () => {
  const navigate = useNavigate()

  return useCallback((event, slug) => {
    if (!slug) return
    event?.stopPropagation?.()
    hapticImpact('light')
    navigate(`/teams/${slug}`)
  }, [navigate])
}

export default useOpenTeam
